/** A state, carried by a word and a mark. Never by hue alone. */

import type { CSSProperties, ReactNode } from "react";

import { cn } from "@/lib/cn";

import "./StatusBadge.css";

export type StatusTone = "neutral" | "success" | "warning" | "danger" | "info";

export interface StatusBadgeProps {
  readonly tone?: StatusTone;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly children?: ReactNode;
}

export function StatusBadge({ tone = "neutral", className, style, children }: StatusBadgeProps) {
  return (
    <span className={cn("al-badge", `al-badge-${tone}`, className)} style={style}>
      <span className="al-badge-mark" aria-hidden="true" />
      <span className="al-badge-text">{children}</span>
    </span>
  );
}
